(function (app) {

    var _activeViewService;

    var action;
    var emitter;
    var stopColumnClick;

    var TYPES = {
        DRAG: 1,
        RESIZE: 2,
        CREATE: 3,
        OPTIONS: 4,
        CLICK: 5,
        LEFT_CLICK: 6,
        COPY: 7
    };

    var EVENTS = {
        SLOT_UPDATED: 'updated',
        SLOT_CREATED: 'created',
        SLOT_RESIZED: 'resized',
        SLOT_MOVED: 'moved',
        SLOT_OPTIONS: 'options',
        SLOT_CLICKED: 'clicked',
        COLUMNS_UPDATED: 'columns_up',
        COLUMN_CLICKED: 'column_clicked',
        ADD_CLICKED: 'add_clicked',
        COLUMN_CLEAR: 'column_clear',
        USER_CLICKED: 'user_clicked',
        DAY_CLICKED: 'day_clicked',
        ALL_CLICKED: 'all_clicked',
        SLOT_CHECK_CHANGED: 'slot_checked',
        EDITS_LOCKED: 'edits_locked'
    };

    var createAction = function (type, event) {

        var newAction = {};

        newAction['type'] = type;
        newAction['offsetX'] = 0;
        newAction['offsetY'] = 0;
        newAction['startX'] = event.pageX;
        newAction['startY'] = event.pageY;

        if (type == TYPES.CREATE || type == TYPES.CLICK) {
            newAction['target'] = $(event.target);

            newAction['columnIndex'] = newAction['target'].index();
            newAction['scheduleIndex'] = newAction['target'].parents(".the-schedule").index();

            newAction['elmStartX'] = 0;
            var stepSize = _activeViewService.vStepPeriod / 4;
            newAction['elmStartY'] = (event.pageY - newAction['target'].offset().top) - ((event.pageY - newAction['target'].offset().top) % stepSize);

            if (type == TYPES.CLICK) {
                newAction['startOffset'] = parseInt(newAction['elmStartY'] / stepSize);
            }
        }
        else {
            newAction['target'] = $(event.currentTarget).parents(".slot");
            var container = newAction['target'].parent();
            var column = newAction['target'].parents(".item.slots-column");
            var schedule = newAction['target'].parents(".the-schedule");
            var slot = newAction['target'];

            newAction['slotIndex'] = slot.index();
            newAction['columnIndex'] = column.index();
            newAction['scheduleIndex'] = newAction['target'].parents(".the-schedule").index();

            newAction['elmStartX'] = parseInt(newAction['target'].css("left"));
            newAction['elmStartY'] = parseInt(newAction['target'].css("top"));

            newAction['startHeight'] = newAction['target'].height();

            if (type == TYPES.COPY) {
                // If the action is COPY, then duplicate the slot
                newAction['target'] = newAction['target'].clone();
                newAction['target'].addClass("copy");
                newAction['target'].find(".warnings").hide();
                container.append(newAction['target']);
            }

            if (type != TYPES.OPTIONS) {
                newAction['target'].addClass("in-action");
            }

            newAction['target'].addClass("active-action");
            container.addClass("active-action");
            container.parent().addClass("active-action");
        }

        newAction['id'] = newAction['target'].parents(".the-schedule").attr("id");
        return newAction;
    };

    var onSlotRightMenu = function (event) {

        if (_activeViewService.isLocked && (!_activeViewService.canPublish || $(event.target).parents('.slot').data('status') == 'PUBLISHED')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            emitter.triggerSync(EVENTS.EDITS_LOCKED);
            return;
        }

        var optionsAction = createAction(TYPES.OPTIONS, event);
        emitter.trigger(EVENTS.SLOT_OPTIONS, optionsAction);
        return false;
    };

    // 300 ms delay as a workaround to separate between click and mouseup and mousedown to move
    var clickIsValid = true;
    var delay = 300;
    var cancelClick;
    var dontClick = function () {
        clickIsValid = false;
    };

    var onSlotLeftClick = function (event) {

        clearTimeout(cancelClick);

        if ($(event.target).hasClass("copy-input")) {
            var itemElm = $(event.target).parents(".item");
            var slotElm = $(event.target).parents(".slot");
            var scheduleElm = itemElm.parents(".the-schedule");
            var itemElmIndex = itemElm.index();

            if (itemElm.find(".slot .copy-input:checked").length == 0) {
                scheduleElm.find("tr:eq(" + (itemElmIndex + 1) + ") .copy-input:checked").click();
            }

            if (itemElm.find(".slot .copy-input:not(:checked)").length == 0) {
                scheduleElm.find("tr:eq(" + (itemElmIndex + 1) + ") .copy-input:not(:checked)").click();
            }

            emitter.trigger(EVENTS.SLOT_CHECK_CHANGED, event, parseInt(slotElm.attr("id")), slotElm.find(".copy-input").is(":checked"));
        }
        else if (
            !stopColumnClick &&
            $(event.currentTarget).hasClass("slot-content") &&
            clickIsValid
        ) {
            var optionsAction = createAction(TYPES.LEFT_CLICK, event);
            emitter.trigger(EVENTS.SLOT_CLICKED, optionsAction);
            return false;
        }

        clickIsValid = true;
    };

    var isRightClick = function (event) {

        var isRightClick = false;

        if ("which" in event) {
            isRightClick = (event.which == 3);
        }
        else {
            isRightClick = (event.button == 2);
        }

        return isRightClick;
    };

    var slotDragHandler = function (event) {

        cancelClick = setTimeout(dontClick, delay);

        if (!isRightClick(event)) {
            if (!action) {

                if (_activeViewService.isLocked) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return;
                }

                // Check Cmd button is pressed on Mac, and Ctrl on other devices (windows, linux)
                var isCtrlCmdPressed = (navigator.platform.indexOf("Mac") == 0 && event.metaKey) || (navigator.platform.indexOf("Mac") == -1 && event.ctrlKey);

                if (isCtrlCmdPressed) {
                    action = createAction(TYPES.COPY, event);
                    $("body").addClass('copy');
                }
                else {
                    action = createAction(TYPES.DRAG, event);
                    $("body").addClass('drag');
                }

                if (action['target'].hasClass("saving")) {
                    action = null;
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

            }
        }
    };

    var slotResizeTopHandler = function (event) {

        if (_activeViewService.isLocked) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        if (!isRightClick(event)) {
            if (!action) {
                action = createAction(TYPES.RESIZE, event);

                if (action['target'].hasClass("saving")) {
                    action = null;
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                action['verticalDirection'] = 'top';
                $("body").addClass('resizeTop');
            }
        }
    };

    var slotResizeBottomHandler = function (event) {

        if (_activeViewService.isLocked) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        if (!isRightClick(event)) {
            if (!action) {
                action = createAction(TYPES.RESIZE, event);

                if (action['target'].hasClass("saving")) {
                    action = null;
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }

                action['verticalDirection'] = 'bottom';
                $("body").addClass('resizeBottom');
            }
        }
    };

    var InterviewDragDropService = function () {
        var self = this;
        emitter = JarEventEmitter.call(self);

        var revertAction = function() {
            if (action.type === TYPES.COPY) {
                action.target.remove();
            } else {
                action.target.css("left", action.elmStartX);
                action.target.css("top", action.elmStartY);
                // _activeViewService.updateTimeOnView(action.target, (action.elmStartY / _activeViewService.stepSize), ((action.elmStartY + action.startHeight) / _activeViewService.stepSize));
            }
        };

        var doActualResize = function () {
            var sizeChange;
            var offsetShift;

            if (action['verticalDirection'] === 'bottom') {
                sizeChange = action.offsetY / _activeViewService.stepSize;
            }
            else {
                offsetShift = Math.floor(action.offsetY / _activeViewService.stepSize);
            }

            var from = {
                columnIndex: action['columnIndex'],
                slotIndex: action['slotIndex']
            };

            _activeViewService.resizeSlot(action, from, offsetShift, sizeChange);
            emitter.triggerSync(EVENTS.SLOT_RESIZED, $.extend({}, action));
        };

        var doActualCreate = function () {

            var offset, size;

            if (action['verticalDirection'] == 'bottom') {
                offset = Math.floor(action.elmStartY / _activeViewService.stepSize);
                size = Math.abs(1 + (action.offsetY / _activeViewService.stepSize));
            }
            else {
                size = Math.abs((action.offsetY / _activeViewService.stepSize)) + 1;
                offset = (Math.ceil(action.elmStartY / _activeViewService.stepSize) - size) + 1;
            }

            var from = {
                columnIndex: action['columnIndex'],
                slotIndex: action['target'].index()
            };

            action.slotIndex = from.slotIndex;
            _activeViewService.createSlot(action, from, offset, size);

            emitter.triggerSync(EVENTS.SLOT_CREATED, $.extend({}, action));
        };

        var doActualMove = function(copy) {
            if (action['offsetX'] || action['offsetY']) {
                var columnsShift = parseInt(action['offsetX'] / _activeViewService.hStepPeriod);

                var to;
                var from = {
                    columnIndex: action['columnIndex'],
                    slotIndex: action['slotIndex']
                };

                if (columnsShift != 0) {
                    var fromColumnIndex = action.target.parent(".slots-column").index();
                    var toColumnIndex = fromColumnIndex + columnsShift;

                    var toColumn = action.target.parents(".the-schedule").find(".slots-column")[toColumnIndex];

                    if (toColumn) {
                        to = {
                            columnIndex: toColumnIndex,
                            slotIndex: 0
                        };

                        // Check if actions is allowed, (if candidate mode listeners should be disabled)
                        if (_activeViewService.isAllowed(from, to, action)) {
                            action.target.css("left", "");
                            action.target.detach().appendTo(toColumn);
                        }
                        else {
                            if (copy) {
                                // In case of invalid copy, just remove the new copied element
                                action.target.remove();
                            }
                            else {
                                revertAction();
                            }
                            return;
                        }
                    }
                    else {
                        revertAction();
                        emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));
                        return;
                    }
                }
                else {
                    to = from;
                }

                // renderData.dataService.shiftSlot(from, (action['offsetX'] / renderData['SLOT_WIDTH']));
                // var newSlotIndex = renderData.dataService.moveSlot(from, to);

                action['columnIndex'] = to['columnIndex'];

                if (copy) {
                    emitter.triggerSync(EVENTS.SLOT_CREATED, $.extend({}, action));
                    _activeViewService.moveSlot(action, from, to, true);
                }
                else {
                    emitter.triggerSync(EVENTS.SLOT_MOVED, $.extend({}, action));
                    _activeViewService.moveSlot(action, from, to);
                }
            }
        };

        self.assignListeners = function (scheduleId, viewOnly) {

            var scheduleWeekStart = getWeekStart(moment(_activeViewService.startDate).startOf('day'), 'MON');
            var currentWeekStart = getWeekStart(moment().startOf('day'), 'MON');
            var doNotBlock = scheduleWeekStart.isAfter(currentWeekStart);

            var currentDayStart = moment().startOf('day');
            var dayDifference = scheduleWeekStart.diff(currentDayStart, 'days');
            var currentTime = moment().endOf('hour').add(1, 'minutes');
            var hourDifference = currentDayStart.diff(currentTime, 'hours');

            var scheduleElm = $(`${_activeViewService.containerParentId ? '#' + _activeViewService.containerParentId : ''} #${scheduleId}`);
            var stepWidth = _activeViewService.hStepPeriod;
            var stepHeight = _activeViewService.stepSize;

            // Minimum offsets to be calculated depending on permission to block or not
            var minimumHorizontalOffset = 0;
            var minimumVerticalOffset = 0;

            if (_activeViewService.blockPastTime && !doNotBlock) {
                if (dayDifference < 0) {
                    minimumHorizontalOffset = Math.abs(dayDifference) * _activeViewService.hStepPeriod;
                }
                if (hourDifference < 0) {
                    minimumVerticalOffset = Math.abs(hourDifference) * _activeViewService.vStepPeriod / stepHeight;
                }
            }

            var originalMinimumVerticalOffset = minimumVerticalOffset;
            var originalMinimumHorizontalOffset = minimumHorizontalOffset;
            // Maximum offsets
            var maximumHorizontalOffset = _activeViewService.columnsCount * _activeViewService.hStepPeriod;
            var maximumVerticalOffset = _activeViewService.rowsCount * _activeViewService.vStepPeriod;

            scheduleElm.find(".all_day").off("click").on("click", function (event) {
                emitter.trigger(EVENTS.ALL_CLICKED, $(this).parents("tr").index() - 1);
            });

            if (!viewOnly) {
                scheduleElm.find(".grid .slot:not(.disabled) .slot-content").off("contextmenu").on("contextmenu", onSlotRightMenu);

                scheduleElm.find(".grid .slot:not(.disabled) .slot-content").off("mousedown").on("mousedown", slotDragHandler);

                scheduleElm.find(".grid .slot:not(.disabled) .slot-content").off("click").on("click", onSlotLeftClick);

                scheduleElm.find(".grid .slot:not(.disabled) .resize-top").off("mousedown").on("mousedown", slotResizeTopHandler);

                scheduleElm.find(".grid .slot:not(.disabled) .resize-bottom").off("mousedown").on("mousedown", slotResizeBottomHandler);

                scheduleElm.find(".grid .slot:not(.disabled) .slot-content").off("mouseup").on("mouseup", function () {
                    clickIsValid = true;
                });

                scheduleElm.find(".grid .slots-column:not(.deactivated)").off("mousedown").on("mousedown", function (event) {

                    if (_activeViewService.isLocked) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        return;
                    }

                    if (!$(event.target).parents(".slot.disabled").length && !action && !isRightClick(event)) {
                        action = createAction(TYPES.CREATE, event);
                        $("body").addClass("create");
                    }
                });

                var mouseScrollTimeout;

                // Auto scroll page when mousemove to the position of an event pageY
                var scrollToMouse = function (eventPageY) {

                    clearTimeout(mouseScrollTimeout);

                    if (!action) return;

                    var scrollTop = $(window).scrollTop();
                    var windowHeight = $(window).height();
                    var documentHeight = $(document).height();
                    var checkAgain;

                    // Start to scroll top if mouse is < 220 pixel from the top
                    // Make sure that scroll is not already zero
                    if (scrollTop > 0 && ((eventPageY - scrollTop) < 220)) {
                        $(window).scrollTop(scrollTop - 20);
                        checkAgain = true;
                    }
                    // Start to scroll down if mouse is < 120 pixel from the bottom
                    // Make sure that page is not fully scrolled
                    else if (((scrollTop + windowHeight) <= (documentHeight - 1)) && ((eventPageY - scrollTop) > (windowHeight - 120))) {
                        $(window).scrollTop(scrollTop + 20);
                        checkAgain = true;
                    }

                    // Keep checking again until we don't need more scroll
                    if (checkAgain) {
                        mouseScrollTimeout = setTimeout(function () {
                            scrollToMouse(eventPageY);
                        }, 50);
                    }
                };

                $(document).off("mousemove.schedule").on("mousemove.schedule", function (event) {
                    if (action) {
                        switch (action.type) {
                            case TYPES.COPY:
                            case TYPES.DRAG:
                                // Stop any previously run checks
                                clearTimeout(mouseScrollTimeout);
                                // Check if we need to update the window scroll to scroll to current mouse position
                                scrollToMouse(parseInt(event.pageY));
                                break;
                        }
                    }
                });

                scheduleElm.off("mousemove").on("mousemove", function(event) {

                    if (action) {

                        var ignore = false;

                        // When moving a slot I want to remove old restrictions and be able to move
                        // at the minimum step size which is 15 minutes always
                        stepHeight = action['type'] == TYPES.DRAG? 15: stepHeight;

                        // the steps that the slot has taken on the X and Y Axes
                        var stepsX = (event.pageX - action['startX']) / stepWidth;
                        var stepsY = (event.pageY - action['startY']) / stepHeight;

                        var originalVerticalOffset = action['elmStartY'] / stepHeight;
                        var originalHorizontalOffset = action['columnIndex'] * stepWidth;
                        var originalVerticalEnd = originalVerticalOffset + (action['startHeight'] / stepHeight);
                        var originalHorizontalEnd = originalHorizontalOffset + (_activeViewService.CONSTANTS.SLOT_WIDTH / stepWidth);

                        var yRoundingPolicy = Math.round;
                        var xRoundingPolicy = Math.round; // action.horizontalDirection == 'right'? Math.ceil: Math.floor;

                        if (action.type == TYPES.RESIZE) {
                            if (action.verticalDirection == 'bottom') {
                                yRoundingPolicy = Math.ceil;
                            }
                            else {
                                yRoundingPolicy = Math.floor;
                            }
                        }

                        originalVerticalEnd = yRoundingPolicy(originalVerticalEnd);
                        var offsetX = xRoundingPolicy(stepsX) * stepWidth;
                        var offsetY = yRoundingPolicy(stepsY) * stepHeight;

                        switch (action.type) {

                            case TYPES.COPY:
                            case TYPES.DRAG:

                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {

                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));

                                    if (_activeViewService.blockPastTime && !doNotBlock) {
                                        if ((action['columnIndex'] + stepsX) > Math.abs(dayDifference)) {
                                            minimumVerticalOffset = 0;
                                        } else {
                                            minimumVerticalOffset = originalMinimumVerticalOffset;
                                        }

                                        if (yRoundingPolicy(originalVerticalOffset) + yRoundingPolicy(stepsY) < Math.abs(hourDifference) * _activeViewService.vStepPeriod / stepHeight) {
                                            minimumHorizontalOffset = (Math.abs(dayDifference) + 1) * stepWidth;
                                        } else {
                                            minimumHorizontalOffset = 0;
                                        }
                                    }

                                    if ((originalHorizontalOffset + (stepsX * stepWidth)) < minimumHorizontalOffset) {
                                        stepsX = (minimumHorizontalOffset - originalHorizontalOffset) / stepWidth;
                                        offsetX = xRoundingPolicy(stepsX) * stepWidth;
                                    }

                                    if ((originalHorizontalEnd + stepsX) > maximumHorizontalOffset) {
                                        stepsX = maximumHorizontalOffset - originalHorizontalEnd;
                                        offsetX = xRoundingPolicy(stepsX) * stepWidth;
                                    }

                                    if ((originalVerticalOffset + stepsY) < minimumVerticalOffset) {
                                        stepsY = minimumVerticalOffset - originalVerticalOffset;
                                        offsetY = yRoundingPolicy(stepsY) * stepHeight;
                                    }

                                    if ((originalVerticalEnd + stepsY) > (maximumVerticalOffset / stepHeight)) {
                                        stepsY = (maximumVerticalOffset - (originalVerticalEnd * stepHeight)) / stepHeight;
                                        offsetY = yRoundingPolicy(stepsY) * stepHeight;
                                    }

                                    action['target'].css("top", action['elmStartY'] + offsetY + "px");
                                    action['target'].css("left", action['elmStartX'] + offsetX + "px");

                                    // update slot time on move
                                    var newStart = action['elmStartY'] + offsetY;
                                    var newHeight = action['startHeight'];

                                    var newStartOffset = newStart / stepHeight;
                                    var newEndOffset = (action['elmStartY'] + newHeight) / stepHeight;
                                    // _activeViewService.updateTimeOnView(action['target'], newStartOffset, newEndOffset);
                                }
                                break;

                            case TYPES.RESIZE:
                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {

                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));

                                    var newStart;
                                    var newHeight;

                                    switch (action['verticalDirection']) {
                                        case 'top':
                                            if ((originalVerticalOffset + stepsY) < minimumVerticalOffset) {
                                                stepsY = minimumVerticalOffset - originalVerticalOffset;
                                                offsetY = yRoundingPolicy(stepsY) * stepHeight;
                                            }

                                            newHeight = action['startHeight'] - offsetY;
                                            newStart = action['elmStartY'] + offsetY;
                                            break;

                                        case 'bottom':
                                            if ((originalVerticalEnd + stepsY) > (maximumVerticalOffset / stepHeight)) {
                                                stepsY = (maximumVerticalOffset - (originalVerticalEnd * stepHeight)) / stepHeight;
                                                offsetY = yRoundingPolicy(stepsY) * stepHeight;
                                            }

                                            newHeight = action['startHeight'] + offsetY;
                                            newStart = action['elmStartY'];
                                            break;
                                    }

                                    var newStartOffset = newStart / stepHeight;
                                    var newEndOffset = (newStart + newHeight) / stepHeight;

                                    if (newHeight >= stepHeight) {
                                        action['target'].css("height", (newHeight - 3) + "px");
                                        action['target'].css("top", (newStart + 2) + "px");

                                        // _activeViewService.updateTimeOnView(action['target'], newStartOffset, newEndOffset);
                                    }
                                    else {
                                        ignore = true;
                                    }
                                }
                                break;

                            case TYPES.CREATE:
                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {
                                    var createdSlot = _activeViewService.createNewSlot(action.id, action['columnIndex'], action);

                                    _activeViewService.updateSlotTime(createdSlot);

                                    var slotHTML = _activeViewService.getSlotHTML(action.id, action['columnIndex'], createdSlot);
                                    var newSlot = $(slotHTML);

                                    $(`${_activeViewService.containerParentId ? '#' + _activeViewService.containerParentId : ''} #${action.id}`).find(".item:eq(" + action['columnIndex'] + ")").append(newSlot);
                                    action['target'] = newSlot;
                                    action['target'].find(".text").on("mousedown", slotDragHandler);
                                    action['target'].find(".resize-top").on("mousedown", slotResizeTopHandler);
                                    action['target'].find(".resize-bottom").on("mousedown", slotResizeBottomHandler);

                                    action['type'] = TYPES.RESIZE;
                                    action['new'] = true;
                                    action['startHeight'] = 1 * stepHeight;
                                    action['startWidth'] = _activeViewService.CONSTANTS.SLOT_WIDTH;

                                    action['verticalDirection'] = (offsetY > 0)? 'bottom': 'top';

                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));
                                }
                                break;
                        }

                        if (!ignore) {
                            action['stepsX'] = xRoundingPolicy(stepsX);
                            action['stepsY'] = yRoundingPolicy(stepsY);
                            action['offsetX'] = offsetX;
                            action['offsetY'] = offsetY;
                        }
                    }
                });

                scheduleElm.find(".grid").off("click").on("click", ".slots-column:not(.deactivated)", function(event) {

                    if (_activeViewService.isLocked && !$(event.target).hasClass("copy-input")) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    if (!stopColumnClick && $(event.target).hasClass("slots-column")) {
                        emitter.trigger(EVENTS.COLUMN_CLICKED, createAction(TYPES.CLICK, event));
                    }
                });

                scheduleElm.find(".grid").off("mouseup").on("mouseup", ".slots-column:not(.deactivated)", function(event) {
                    if (action) {

                        $(".active-action").removeClass("active-action");

                        switch (action.type) {
                            case TYPES.DRAG:
                                doActualMove();
                                break;
                            case TYPES.COPY:
                                doActualMove(true);
                                break;

                            case TYPES.RESIZE:
                                if (action.new) {
                                    doActualCreate();
                                }
                                else {
                                    doActualResize();
                                }
                                break;
                        }

                        if (action.type != TYPES.CREATE && !(action.offsetX == 0 && action.offsetY == 0)) {
                            stopColumnClick = true;
                            setTimeout(function() {
                                stopColumnClick = false;
                            }, 250);
                        }

                        action = null;
                        $("body").removeClass("drag resizeRight resizeLeft create copy");
                        $(".in-action").removeClass("in-action");
                    }
                });

                $("body").off("mouseup").on("mouseup", function(event) {
                    if (action) {

                        switch (action.type) {
                            case TYPES.DRAG:
                                emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));
                            case TYPES.COPY:
                                revertAction();
                                break;

                            case TYPES.RESIZE:
                                if (action.new) {
                                    doActualCreate();
                                }
                                else {
                                    doActualResize();
                                }
                                break;
                        }

                        if (action.type != TYPES.CREATE && !(action.offsetX == 0 && action.offsetY == 0)) {
                            stopColumnClick = true;
                            setTimeout(function() {
                                stopColumnClick = false;
                            }, 250);
                        }

                        action = null;
                        $("body").removeClass("drag resizeRight resizeLeft create");
                        $(".in-action").removeClass("in-action");
                    }
                });
            }
            else {
                scheduleElm.find(".grid .slot.disabled .slot-content").off("click").on("click", function (event) {
                    $(".grid .slot.selected").removeClass("selected");
                    $(this).parents('.slot').addClass('selected');
                    emitter.trigger(EVENTS.SLOT_CLICKED, createAction(TYPES.LEFT_CLICK, event));
                });
            }
        };
    };

    InterviewDragDropService.prototype.EVENTS = EVENTS;

    app.service('InterviewDragDropService', [function () {
        return function (ViewService) {
            _activeViewService = ViewService;
            return new InterviewDragDropService();
        }
    }]);

})(angular.module('harriApp.interviewV2'));